// Phase 8 — Barcode preview/download dialog, migrated to shadcn/Tailwind.
//
// UI only: the antd <Modal> becomes a shadcn <Dialog>. The jsbarcode canvas
// rendering, the tap-to-download PNG logic and the JSZip export are all unchanged.
import React, { useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'ui/dialog';
import JSZip from 'jszip';
import { saveAs } from "file-saver";

const BarCode = (props: any) => {
    const {
        product,
        setOpen,
        open,
        checkRecords,
        setProduct
    } = props

    const customizeCanvas = () => {

        const canvas: any = document.querySelector('#barcode' + product?.productId);

        const ctx = canvas.getContext('2d');
        const barcodeMargin = 40;
        JsBarcode(canvas, product?.productId, {
            format: 'CODE128',
            ean128: false,
            margin: barcodeMargin,
            height: 40
        });
        const x = (-canvas.width / 2) + barcodeMargin;
        const y = barcodeMargin - (barcodeMargin / 2);

        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.fillText(product?.productName, x, y, canvas.width);
        ctx.fillText("Rs." + product?.mrp, x, canvas.height - 10, canvas.width);
        canvas.addEventListener('click', download, false);
    }

    useEffect(() => {
        if (open) {
            customizeCanvas()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const download = () => {
        let canvas: any = document.getElementById("barcode" + product?.productId);
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = `${product?.productId}.png`;
        document.body.appendChild(downloadLink);

        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    const clearProduct = () => {
        setProduct("")
        setOpen(false)
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const downloadZip = () => {
        var zip = new JSZip();
        for (let item of checkRecords) {
            let canvas: any = document.getElementById("barcode" + item?.productId);
            let dataURL = canvas.toDataURL("Canvas");
            canvas = null;
            var base64String = dataURL.replace("data:image/png;base64,", "");
            zip.file(`${item.value}.png`, base64String, { base64: true });
        }
        zip.generateAsync({ type: "blob" }).then(function (content) {
            saveAs(content, "bardcodes.zip");
        });
    }

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) clearProduct(); }}>
            <DialogContent className="max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-sm font-medium">Tap the barcode for download</DialogTitle>
                </DialogHeader>
                <canvas
                    className="max-h-full w-full cursor-pointer"
                    onClick={clearProduct}
                    id={"barcode" + product?.productId}
                />
            </DialogContent>
        </Dialog>
    );
}

export default BarCode;
